var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { fetchAllPlayers } from '../../game/connection/server-connection';
import { shuffle, smoothSpeedInterpolate } from '../../lib/util';
import { buttonStyles } from '../button';
let TitleComponent = class TitleComponent extends LitElement {
    constructor() {
        super();
        this.players = [];
        // Fetch players from the server
        fetchAllPlayers().then((players) => {
            this.players = players;
            shuffle(this.players, Math.random);
        });
    }
    render() {
        const totalAnimationLengthSec = 10;
        const playerTemplates = [];
        for (let i = 0; i < this.players.length; i++) {
            const iRatio = i / (this.players.length - 1);
            const player = this.players[i];
            const animationAmt = smoothSpeedInterpolate(iRatio, 3, 1.5);
            const animationDelaySec = animationAmt * totalAnimationLengthSec;
            playerTemplates.push(html `
                <div class="player" style="animation-delay: ${animationDelaySec}s">
                    <player-canvas class="player-canvas" .player=${player}></player-canvas>
                    <p class="player-label">${player.player}</p>
                </div>
            `);
        }
        return html `
            <header class="header">
                <h1 class="main-title">Echos of Players Past</h1>
                <!-- shadow element for the title. Not selectable, etc. -->
                <h1 class="title-shadow">Echos of Players Past</h1>
                <p>By <a href="https://jezzamon.com">Jezzamon</a></p>
                <h3>Starring...</h3>
            </header>
            <div class="players">${playerTemplates}</div>
            <footer class="footer">
                <button
                    class="go-button button"
                    @click=${() => {
            this.dispatchEvent(new CustomEvent('hide-title', {
                bubbles: true,
                composed: true,
            }));
        }}
                >
                    Start Game
                </button>
            </footer>
        `;
    }
};
TitleComponent.styles = [
    buttonStyles,
    css `
            :host {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                background-color: #b86f50;
                color: #ead4aa;
            }

            .header {
                position: relative;
                background-color: #3f2832;
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
            }

            h1 {
                text-align: center;
                font-size: 3em;
            }

            .main-title {
                position: relative;
                /* multiple unblurred shadows to create an outline effect */
                text-shadow: -4px -4px 0 #3f2832, 4px -4px 0 #3f2832, -4px 4px 0 #3f2832,
                    4px 4px 0 #3f2832, 4px 0 0 #3f2832, 0 4px 0 #3f2832, -4px 0 0 #3f2832,
                    0 -4px 0 #3f2832;
                z-index: 2;
            }

            .title-shadow {
                color: transparent;
                position: absolute;
                text-shadow: -4px -4px 2px #21151b, 4px -4px 2px #21151b, -4px 4px 2px #21151b,
                    4px 4px 2px #21151b, 4px 0 2px #21151b, 0 4px 2px #21151b, -4px 0 2px #21151b,
                    0 -4px 2px #21151b;
                top: 10px;
                left: 0;
                right: 0;
                scale: 1.1;
                z-index: 0;
                user-select: none;
            }

            .players {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                flex: 1;
                padding: 30px 5vw 10px;

                color: white;
            }

            @keyframes player-appear {
                0% {
                    opacity: 0;
                }
                1% {
                    opacity: 1;
                    transform: scale(1.1);
                }
                10% {
                    opacity: 1;
                    transform: scale(1.3);
                }
                100% {
                    transform: scale(1);
                    opacity: 1;
                }
            }

            .player {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: -30px 4px;
                border-radius: 5px;
                height: 0px;
                transform-origin: 25px 25px;

                animation: player-appear 0.2s both;
            }

            .player:hover {
                transform: scale(1.1);
                z-index: 1;
            }

            .player-canvas {
                width: 50px;
                height: 50px;
            }

            .player-label {
                text-align: center;
                font-size: 10px;
                background-color: #b86f50;
                padding: 2px;
                margin: 3px 0;
            }

            .go-button {
                margin: 40px 0;
            }

            .footer {
                width: 100%;
                display: flex;
                justify-content: center;
                background-color: #3f2832;
            }

            a {
                color: inherit;
            }

            a:hover {
                color: white;
            }
        `,
];
__decorate([
    state()
], TitleComponent.prototype, "players", void 0);
TitleComponent = __decorate([
    customElement('title-component')
], TitleComponent);
export { TitleComponent };
